import './expertise.scss';
import Swiper from 'swiper/bundle';

export default () => {
	// Desktop Swiper
    const slider = document.querySelector('.js-expertise-slider');
    if (slider && !slider.classList.contains('no-swiper')) {
        new Swiper('.js-expertise-slider', {
            speed: 500,
            loop: true,
            slidesPerView: 1.2,
            spaceBetween: 20,
            navigation: {
                nextEl: ".expertise-button-next",
                prevEl: ".expertise-button-prev",
            },
            breakpoints: {
                640: {
                    slidesPerView: 2.5,
                },
                1024: {
                    slidesPerView: 4,
                },
            },
        });
    }

    // Mobile Swiper
    const mobileSlider = document.querySelector('.js-expertise-slider-mobile');
    if (mobileSlider) {
        new Swiper('.js-expertise-slider-mobile', {
            speed: 500,
            loop: true,
            slidesPerView: 1.2,
            spaceBetween: 20,
            navigation: {
                nextEl: ".expertise-button-next-mobile",
                prevEl: ".expertise-button-prev-mobile",
            },
            breakpoints: {
                640: {
                    slidesPerView: 2.5,
                },
                1024: {
                    slidesPerView: 4,
                },
            },
        });
    }
};
